import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportEndpoint } from '../constants/transport-endpoint';
import { TransportFilterName } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class TransportFiltersService {
  constructor(private http: WrapperHttpService) {}

  getTransportFilters(): Observable<TransportFilterName[]> {
    const url = `${API_URL}${TransportEndpoint.Base}${TransportEndpoint.Filters}`;
    return this.http.withLoading().get<TransportFilterName[]>(url);
  }

  updateTransportFilters(filters: TransportFilterName[]): Observable<TransportFilterName[]> {
    const url = `${API_URL}${TransportEndpoint.Base}${TransportEndpoint.Filters}`;
    return this.http.withLoading().post<TransportFilterName[]>(url, filters);
  }
}
